export const DEFAULT_ERROR = 'PAYMENT_METHOD_POLLER_DEFAULT_GATEWAY_ERROR';

export const mapPollerErrorToTK = (type) => {
    switch (type) {
        case 'paypal':
            return 'PAYMENT_METHOD_POLLER_PAYPAL_ERROR';

        default:
            return DEFAULT_ERROR;
    }
};
